import request from "@/router/axios"
export const get = (params) => {
    return request({
        url: `/api/jc/bill/get`,
        method: 'get',
        params
    })
}
export const getDetail = (appId) => {
    return request({
        url: `/api/jc/record/getDetail`,
        method: 'get',
        params: {
            appId
        }
    })
}